import {
	Alert,
	Box,
	CircularProgress,
	Divider,
	IconButton,
	Stack,
	TextareaAutosize,
	Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomButton from '../CustomButton/CustomButton';
import CustomDatePicker from '../CustomDatePicker/CustomDatePicker';
import LabeledTextField from '../CustomTextField/LabeledTextField';
import ProductsListing from '../ProductListing/ProductsListing';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import { AxiosError, AxiosResponse } from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';
import CustomAlert from '../CustomAlert/CustomAlert';
import { useAppDispatch, useAppSelector } from '@src/store/hooks';
import { setCart } from '@src/store/reducers/cartReducer';
import {
	ArrowBack,
	CartRemoveIcon,
	ModalCloseIcon,
	SaveForReviewIcon2,
	SaveReviewIcon,
	SlideCancelIcon,
} from '../Icons';
import Warning from '../Warning/Warning';
import Cart from '@src/assets/icons/clear-cart.svg';
import {
	convertUTCDateIntoIndianTimezone,
	formatPriceValue,
	parseDate,
} from '@src/helpers/Helpers';
import StoreIcon from '@mui/icons-material/Store';
import usePermission from '@src/hooks/usePermission';
import { ALL_PERMISSION_MAP } from '@src/helpers/Permission';
import CustomTooltip from '../CustomTootip/CustomTooltip';
import CustomDateTimePicker from '../CustomDateTimePicker/CustomDateTimePicker';
import CustomTextButton from '../CustomButton/CustomTextButton';
import { CustomAlertType } from '@src/interfaces/type';
import { IsMobileWidth } from '../MediaQueryUtils';
import ProductCustomCard from '../CustomCard/ProductCustomCard';
import CustomModal from '../CustomModal';
import ProductDetails from '../ProductDetails/ProductDetails';
import ProductCard from '../CustomCard/ProductCard';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

const StyledTextareaAutosize = styled(TextareaAutosize)`
	width: 100%;
	height: 57px !important;
	border: 1.5px solid #e9e9e9;
	margin-top: 8px;
	resize: none;
	border-radius: 4px;
	padding: 2px 8px;
	&:focus-visible {
		outline: #e9e9e9;
	}
	&:hover {
		border-color: #7d7d7d9e;
	}
	&::placeholder {
		color: #acacac;
		font-weight: 600;
		font-family: Nunito Sans;
	}
`;

const productDetailsModalStyles = {
	backgroundColor: 'background.paper',
	borderRadius: '4px',
	boxShadow: '24px',
	maxWidth: '600px',
	maxHeight: '444px',
	'@media (max-width: 600px)': {
		width: '90%',
		maxWidth: '90%',
		maxHeight: '645px',
		height: '645px',
	},
};

const IconContainer = styled('div')({
	display: 'flex',
	alignItems: 'center',
});

const StyledBottomBtnContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 72px;
	padding: 16px;
	background: var(--chat-header-bg);
	border: 1.5px solid var(--gray-color-light);
	z-index: 10;
	flex-shrink: 0; // Prevents resizing when the content overflows
`;

const ProductContainer = styled.div({
	background: '#F1F1F1',
	paddingTop: '2px',
	// overflowY: 'auto',
	// flexGrow: 1, // Ensure it takes up remaining space and allows scrolling
});

const fontStyles = {
	color: 'var(--Black, #1A1A1A)',
	fontFamily: 'Nunito Sans',
	fontSize: '18px',
	fontWeight: 700,
	lineHeight: '24px',
};
interface CartComponentProps {
	cartData: any;
	waId: string;
	restaurantId: string;
	setOpenModal: (isOpen: boolean) => void;
	setCartItemModal: (isOpen: boolean) => void;
	setResponseMessage: (message: CustomAlertType) => void;
	setCartData: (data: any) => void;
	checkForCartData: (waId: string, id: string) => void;
	setWidth: (width: string) => void;
	setApiCall: (apiCall: boolean) => void;
	displayCustomError: (error: string) => void;
	selectedDate: any;
	setSelectedDate: any;
	selectedDateTime: any;
	setSelectedDateTime: any;
	comment: any;
	setComment: any;
	setProductsBackUp: any;
	rewardsInfo: any;
	creditInfo: any;
}

export function RenderLessAndPayableAmount({ rewardsInfo, total }: any) {
	if (!rewardsInfo) return null;
	const { rewardsDiscount } = rewardsInfo || {
		rewardsDiscount: 0,
	};

	return (
		<>
			<Typography variant="body2" sx={{ fontWeight: '700' }}>
				Less Rewards: ₹ {formatPriceValue(rewardsDiscount) || 0}
			</Typography>
			<Typography variant="body2" sx={{ fontWeight: '700' }}>
				Payable Amount: ₹ {formatPriceValue(total - rewardsDiscount) || 0}
			</Typography>
		</>
	);
}

function CartComponent({
	cartData,
	waId,
	restaurantId,
	setOpenModal,
	setCartItemModal,
	setResponseMessage,
	setCartData,
	checkForCartData,
	setWidth,
	setApiCall,
	displayCustomError,
	selectedDate,
	setSelectedDate,
	selectedDateTime,
	setSelectedDateTime,
	comment,
	setComment,
	setProductsBackUp,
	rewardsInfo,
	creditInfo,
}: CartComponentProps) {
	const selectedBranch: any = useAppSelector((state) => state?.restaurant?.value?.default);
	const [btnLoading, setBtnLoading] = useState(false);
	const [reviewBtnLoading, setReviewBtnLoading] = useState(false);
	const [itemsData, setItemsData] = useState([]);
	const [isDisabled, setIsDisabled] = useState(false);
	const [totalPrice, setTotalPrice] = useState(null);
	const { apiService }: any = React.useContext(ApplicationContext);
	const [error, setError] = useState('');
	const [warning, setWarning] = useState(false);
	const [showCreditWarningModal, setShowCreditWarningModal] = useState(false);
	const [detailsMiodal, setDetailsModal] = useState(false);
	const [productDetails, setProductDetails] = useState([]);

	const isMobileWidth = IsMobileWidth();

	//Mobile Screen States
	const [windowDimensions, setWindowDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});

	const updateWindowDimensions = () => {
		setWindowDimensions({
			width: window.innerWidth,
			height: window.innerHeight,
		});
	};

	const cart: any = useAppSelector((state) => state?.cart?.value);
	const dispatch = useAppDispatch();

	//Permissions
	const checkPermission = usePermission();
	const canSaveCart = checkPermission(ALL_PERMISSION_MAP?.RESTAURANT?.CART?.SAVE, waId);
	const canClearCart = checkPermission(ALL_PERMISSION_MAP?.RESTAURANT?.CART?.CLEAR, waId);
	const canViewCart = checkPermission(ALL_PERMISSION_MAP?.RESTAURANT?.CART?.VIEW, waId);
	const canCreateCart = checkPermission(ALL_PERMISSION_MAP?.RESTAURANT?.CART?.UPDATE, waId);

	useEffect(() => {
		const cartItemsData = cartData?.cart?.map((item: any) => ({
			id: item?.productId,
			image: item?.images?.[0]?.image,
			category: item?.category?.name,
			categoryId: item?.category?.id,
			name: item?.name,
			unit: item?.unit,
			price: formatPriceValue(item?.customerPrice),
			quantity: item?.quantity,
			maxPrice: formatPriceValue(item?.maxPrice),
			subCategory: item?.subCategory?.name,
			subCategoryId: item?.subCategory?.id,
			machineBrand: item?.machineBrand?.name,
			machineBrandId: item?.machineBrand?.id,
			machineModel: item?.machineModel?.name,
			machineModelId: item?.machineModel?.id,
			groupCategory: item?.groupCategory?.name,
			groupCategoryId: item?.groupCategory?.id,
			brand: item?.brand?.name,
			brandId: item?.brand?.id,
			partComposition: item?.partComposition?.name,
			partCompositionId: item?.partComposition?.id,
			partDesign: item?.partDesign?.name,
			partDesignId: item?.partDesign?.id,
			partDiameter: item?.partDiameter?.name,
			partDiameterId: item?.partDiameter?.id,
			partDimension: item?.partDimension?.name,
			partDimensionId: item?.partDimension?.id,
			partOwnership: item?.partOwnership?.name,
			partOwnershipId: item?.partOwnership?.id,
			partQuality: item?.partQuality?.name,
			partQualityId: item?.partQuality?.id,
			partWeight: item?.partWeight?.name,
			partWeightId: item?.partWeight?.id,
			partPerformance: item?.partPerformance?.name,
			partPerformanceId: item?.partPerformance?.id,
		}));
		setItemsData(cartItemsData);
		let totalPrice = 0;
		for (const item of cartItemsData) {
			const quantity = parseInt(item.quantity);
			const price = parseFloat(item.price);
			totalPrice += quantity * price;
		}
		setTotalPrice(formatPriceValue(totalPrice));
	}, []);

	const saveForReview = (data: any, waId: any, id: string) => {
		setReviewBtnLoading(true);
		setIsDisabled(true);
		apiService.saveCartInfo(
			data,
			(response: AxiosResponse) => {
				setResponseMessage({
					message: 'Order saved successfully for review.',
					severity: 'success',
				});
				setOpenModal(false);
				// setShowOrderSummary(false);
				checkForCartData(waId, id);
				setReviewBtnLoading(false);
				setIsDisabled(false);
			},
			(error: AxiosError) => {
				// setResponseMessage({
				// 	message: 'Something went wrong.',
				// 	severity: 'error',
				// });
				console.log(error);
				// setShowOrderSummary(false);
				setReviewBtnLoading(false);
				setIsDisabled(false);
				//@ts-ignore
				displayCustomError(error);
			},
			selectedBranch?.phone,
			waId,
			id
		);
	};
	const resetCart = () => {
		dispatch(setCart({ ...cart, [waId]: [] }));
	};

	const submitOrder = (data: any, waId: any, id: string) => {
		setBtnLoading(true);
		setIsDisabled(true);
		apiService.createOrder(
			data,
			(response: AxiosResponse) => {
				setResponseMessage({
					message: 'Order created successfully.',
					severity: 'success',
				});
				setCartData(null);
				setOpenModal(false);
				setBtnLoading(false);
				setIsDisabled(false);
				setWidth('1118px');
				setWarning(false);
				setItemsData((prevState: any) => {
					return prevState?.map((item: any) => {
						return { ...item, background: '' };
					});
				});
				clearCart();
			},
			(error: AxiosError) => {
				// setResponseMessage({
				// 	message: 'Something went wrong.',
				// 	severity: 'error',
				// });
				console.log(error);
				setBtnLoading(false);
				setIsDisabled(false);
				//@ts-ignore
				displayCustomError(error);
			},
			selectedBranch?.phone,
			waId
		);
	};

	const clearCart = () => {
		const data = itemsData?.map((item) => {
			//@ts-ignore
			return { id: item?.id, quantity: Number(item?.quantity) };
		});
		apiService?.clearCartData(
			data,
			(response: any) => {
				setOpenModal(false);
				setApiCall(true);
				setWidth('1118px');
				setWarning(false);
				setItemsData((prevState: any) => {
					return prevState?.map((item: any) => {
						return { ...item, background: '' };
					});
				});
				setProductsBackUp([]);
			},
			(error: AxiosError) => {
				// setResponseMessage({
				// 	message: 'Something went wrong.',
				// 	severity: 'error',
				// });
				//@ts-ignore
				displayCustomError(error);
			},
			selectedBranch?.phone,
			waId,
			restaurantId
		);
	};

	const handleSaveForReview = () => {
		const data = {
			comments: comment,
			createdAt: selectedDateTime,
		};

		if (selectedDate) {
			//@ts-ignore
			data.requestedDate = moment(new Date(selectedDate as string)).format(
				'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
			);
		}

		saveForReview(data, waId, restaurantId);
	};

	const handleSubmitOrder = () => {
		const data = {
			comments: comment,
			requestedDate: selectedDate
				? moment(new Date(selectedDate as string)).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
				: null,
			createdAt: selectedDateTime,
		};
		submitOrder(data, waId, restaurantId);
	};

	const maxPriceWarning = () => {
		if (
			creditInfo?.allowNewOrders == false &&
			creditInfo?.isActive &&
			creditInfo?.creditAvailable <= 0
		) {
			setShowCreditWarningModal(true);
			return;
		}

		const warning = itemsData?.some((item: any) =>
			item?.maxPrice && Number(item?.maxPrice) !== 0
				? Number(item?.price) > Number(item?.maxPrice)
				: false
		);
		if (warning) {
			setWarning(true);
			setIsDisabled(true);
			const ids = itemsData?.map((item: any) => {
				const maxPrice = Number(item?.maxPrice);
				const price = Number(item?.price);
				if (maxPrice && maxPrice !== 0 && price > maxPrice) {
					return item?.id?.toString();
				}
			});
			setItemsData((prevState: any) => {
				return prevState?.map((item: any) => {
					if (ids.includes(item?.id)) {
						return { ...item, background: '#FFFDF5' };
					}
					return item;
				});
			});
		} else {
			handleSubmitOrder();
		}
	};

	const showDetails = (product: any) => {
		setProductDetails(product);
		setDetailsModal(true);
	};

	const isDisableButton = (selectedDate: any) => {
		return false;
		if (!selectedDate) {
			return true;
		}

		const momentSelectedDate = moment(new Date(selectedDate)).format('YYYY-MM-DD');
		const momentOrderDate = moment(new Date(selectedDateTime)).format('YYYY-MM-DD');

		return moment(momentSelectedDate).isBefore(momentOrderDate);
	};

	//For Mobile Screen
	useEffect(() => {
		window.addEventListener('resize', updateWindowDimensions);

		return () => {
			window.removeEventListener('resize', updateWindowDimensions);
		};
	}, []);

	useEffect(() => {
		updateWindowDimensions();
	}, []);

	const modals = () => {
		if (detailsMiodal && productDetails) {
			return (
				<CustomModal
					open={detailsMiodal}
					setOpen={setDetailsModal}
					header={false}
					style={productDetailsModalStyles}
				>
					{/* @ts-ignore */}
					<ProductDetails data={productDetails} setOpenModal={setDetailsModal} />
				</CustomModal>
			);
		}
	};

	// if (isMobileWidth) {
	// 	return (
	// 		<Box
	// 			sx={{
	// 				width: '100%',
	// 				height: '100vh',
	// 				display: 'flex',
	// 				flexDirection: 'column', // Arrange children in a column
	// 				overflow: 'hidden',
	// 			}}
	// 		>
	// 			<Box
	// 				display="flex"
	// 				justifyContent="space-between"
	// 				alignItems="center"
	// 				px={2}
	// 				width="100%"
	// 				height="56px"
	// 				flexShrink={0} // Prevents resizing when the content overflows
	// 			>
	// 				<div style={{ display: 'flex', alignItems: 'center' }}>
	// 					<IconButton
	// 						onClick={() => {
	// 							setOpenModal(false);
	// 						}}
	// 						size="large"
	// 					>
	// 						<ArrowBack />
	// 					</IconButton>
	// 					<Box>
	// 						<p
	// 							style={{
	// 								color: '#5C5C5C',
	// 								fontFamily: 'Poppins',
	// 								fontSize: '16px',
	// 								fontWeight: 400,
	// 							}}
	// 						>
	// 							Order Summary
	// 						</p>
	// 					</Box>
	// 				</div>
	// 				<IconContainer>
	// 					{canClearCart ? (
	// 						<CustomTooltip placement="top" title="Remove All Items from Cart">
	// 							<IconButton
	// 								onClick={() => {
	// 									clearCart();
	// 									setResponseMessage({
	// 										message: 'Cart Clear Successfully',
	// 										severity: 'success',
	// 									});
	// 								}}
	// 							>
	// 								{/* @ts-ignore */}
	// 								<CartRemoveIcon />
	// 							</IconButton>
	// 						</CustomTooltip>
	// 					) : (
	// 						<CustomTooltip
	// 							placement="top"
	// 							title="You do not have permission to clear cart. Contact
	// 			an administrator to get permission."
	// 						>
	// 							<span>
	// 								<IconButton disabled>
	// 									{/* @ts-ignore */}
	// 									<CartRemoveIcon />
	// 								</IconButton>
	// 							</span>
	// 						</CustomTooltip>
	// 					)}
	// 					{canSaveCart ? (
	// 						<CustomTooltip placement="top" title="Save For Review">
	// 							<IconButton onClick={handleSaveForReview}>
	// 								<SaveForReviewIcon2 />
	// 							</IconButton>
	// 						</CustomTooltip>
	// 					) : (
	// 						<CustomTooltip
	// 							placement="top"
	// 							title={`You do not have permission to edit orderbook. Contact
	// 						an administrator to get permission.`}
	// 						>
	// 							<span>
	// 								<IconButton disabled>
	// 									<SaveForReviewIcon2 />
	// 								</IconButton>
	// 							</span>
	// 						</CustomTooltip>
	// 					)}
	// 				</IconContainer>
	// 			</Box>
	// 			<Divider style={{ width: '100%' }} />
	// 			<Box sx={{ overflowY: 'auto', flexGrow: 1 }}>
	// 				{warning ? (
	// 					<Box sx={{ p: '16px' }}>
	// 						{warning ? (
	// 							<Warning
	// 								onClick={handleSubmitOrder}
	// 								message="The prices of some items have been updated by the supplier. Please review the new prices before confirming your order."
	// 								btnStyles={{ width: '215px' }}
	// 								tootip={!selectedDate}
	// 								tooltipTitle="Select date first"
	// 							/>
	// 						) : null}
	// 					</Box>
	// 				) : null}
	// 				<div
	// 					style={{
	// 						display: 'flex',
	// 						alignItems: 'center',
	// 						justifyContent: 'space-between',
	// 						padding: '16px',
	// 					}}
	// 				>
	// 					<Box sx={{ display: 'flex', alignItems: 'center' }}>
	// 						{canCreateCart ? (
	// 							<CustomTextButton
	// 								title="Edit Cart"
	// 								onClick={() => {
	// 									setOpenModal(false);
	// 									setCartItemModal(true);
	// 								}}
	// 							/>
	// 						) : null}
	// 					</Box>
	// 					<div
	// 						style={{
	// 							color: '#333333',
	// 							fontSize: '13px',
	// 							fontWeight: 500,
	// 							flexShrink: 0,
	// 						}}
	// 					>
	// 						{/* @ts-ignore */}
	// 						Qty: {itemsData?.reduce((total, item) => total + item?.quantity, 0)} items
	// 					</div>
	// 				</div>
	// 				<form style={{ width: '100%', flexShrink: 0, overflow: 'hidden' }}>
	// 					<Box sx={{ px: '16px' }}>
	// 						<Box sx={{ marginBottom: '16px' }}>
	// 							<CustomDateTimePicker
	// 								label="Select Date and Time"
	// 								styles={{ width: '100%', height: '36px' }}
	// 								selectedDateTime={selectedDateTime}
	// 								onDateTimeChange={(dateTime) => {
	// 									setSelectedDateTime(dateTime);
	// 								}}
	// 								disabled={false}
	// 								windowDimensions={windowDimensions}
	// 								maxDateTime={selectedDate}
	// 							/>
	// 						</Box>

	// 						<Typography variant="body2" sx={{ mt: '-6px', color: 'var(--color-font-grey)' }}>
	// 							Request Delivery Date *
	// 						</Typography>
	// 						<CustomDatePicker
	// 							styles={{ width: '100%' }}
	// 							selectedDate={selectedDate}
	// 							onDateChange={(newDate) => {
	// 								//Getting date in UTC, adding minutes according to indian timezone diff
	// 								setSelectedDate(convertUTCDateIntoIndianTimezone(newDate as Date));
	// 							}}
	// 							minDate={selectedDateTime}
	// 						/>
	// 						{/* <Typography variant="body2" sx={{ mt: '16px', color: 'var(--color-font-grey)' }}>
	// 					Leave a comment
	// 				</Typography>
	// 				<StyledTextareaAutosize
	// 					value={comment}
	// 					onChange={(e) => setComment(e.target.value)}
	// 					placeholder="leave a comment"
	// 					maxLength={200}
	// 				/> */}
	// 						<Box sx={{ marginTop: '8px' }}>
	// 							<LabeledTextField
	// 								label="Leave a comment"
	// 								value={comment}
	// 								onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
	// 									setComment(e.target.value as string)
	// 								}
	// 								multiline
	// 								rows={4}
	// 								placeholder="leave a comment"
	// 								styles={{ width: '100%' }}
	// 							/>
	// 						</Box>
	// 					</Box>
	// 					<Box sx={{ p: '16px', pb: '6px' }}>
	// 						<Box display="flex" width="100%" justifyContent="space-between" sx={{ mb: '16px' }}>
	// 							<Typography variant="body1">Your Products</Typography>
	// 							<Typography variant="body2" style={{ color: 'var(--lighter-text-color)' }}>
	// 								{itemsData?.length} Products
	// 							</Typography>
	// 						</Box>
	// 					</Box>
	// 					<Divider style={{ width: '100%' }} />
	// 				</form>

	// 				<ProductContainer>
	// 					{itemsData?.map((item: any) => {
	// 						return <ProductCustomCard key={item?.id} product={item} readOnlyCounter />;
	// 					})}
	// 				</ProductContainer>
	// 			</Box>

	// 			<StyledBottomBtnContainer>
	// 				<div
	// 					style={{
	// 						display: 'flex',
	// 						flexDirection: 'column',
	// 						color: '#5C5C5C',
	// 						fontSize: '11px',
	// 						fontWeight: 600,
	// 					}}
	// 				>
	// 					<span>Total Amount:</span>
	// 					<span style={{ color: '#1A1D1F', fontSize: '14px' }}>₹ {totalPrice}</span>
	// 				</div>
	// 				<CustomButton
	// 					color="primary"
	// 					title={
	// 						btnLoading ? (
	// 							<CircularProgress size={16} style={{ color: 'var(--default-text-color)' }} />
	// 						) : (
	// 							'Submit Order'
	// 						)
	// 					}
	// 					disabled={isDisabled || isDisableButton(selectedDate)}
	// 					handleClick={maxPriceWarning}
	// 					styles={{
	// 						width: '143px',
	// 						height: '36px',
	// 						borderRadius: '4px',
	// 					}}
	// 				/>
	// 			</StyledBottomBtnContainer>
	// 		</Box>
	// 	);
	// }
	return (
		<Box
			sx={{
				width: '100%',
				height: '572px',
				'@media (max-width: 768px)': {
					width: '100%',
					maxWidth: '100%',
					height: '100%',
					maxHeight: '100%',
				},
			}}
		>
			<Box
				display="flex"
				justifyContent="space-between"
				alignItems="center"
				px={2}
				width="100%"
				height="56px"
			>
				<Box>
					<p style={fontStyles}>Order Summary</p>
				</Box>
				<Box display="flex" justifyContent="flex-end" gap="8px" alignItems="center">
					{windowDimensions?.width > 800 ? (
						<>
							{canCreateCart ? (
								<CustomTextButton
									title="Edit Cart"
									onClick={() => {
										setOpenModal(false);
										setCartItemModal(true);
										setWidth('1118px');
									}}
								/>
							) : null}
							{canClearCart ? (
								<CustomTooltip placement="top" title="Remove All Items from Cart">
									<IconButton onClick={clearCart}>
										{/* @ts-ignore */}
										<img src={Cart} width="22px" height="20px" alt="shopping-cart" />
									</IconButton>
								</CustomTooltip>
							) : (
								<CustomTooltip
									placement="top"
									title="You do not have permission to clear cart. Contact 
				an administrator to get permission."
								>
									<span>
										<IconButton disabled>
											{/* @ts-ignore */}
											<img src={Cart} width="22px" height="20px" alt="shopping-cart" />
										</IconButton>
									</span>
								</CustomTooltip>
							)}
							{canSaveCart ? (
								<CustomTooltip placement="top" title="Save For Review">
									<IconButton onClick={handleSaveForReview}>
										<SaveReviewIcon />
									</IconButton>
								</CustomTooltip>
							) : (
								<CustomTooltip
									placement="top"
									title={`You do not have permission to edit orderbook. Contact 
							an administrator to get permission.`}
								>
									<span>
										<IconButton disabled>
											<SaveReviewIcon stroke="#cacaca" />
										</IconButton>
									</span>
								</CustomTooltip>
							)}
							<CustomButton
								// type="submit"
								// title="Submit Order"
								color="primary"
								title={
									btnLoading ? (
										<CircularProgress size={16} style={{ color: 'var(--default-text-color)' }} />
									) : (
										'Submit Order'
									)
								}
								disabled={isDisabled || isDisableButton(selectedDate)}
								handleClick={maxPriceWarning}
								styles={{
									width: '143px',
									height: '36px',
									borderRadius: '4px',
								}}
							/>
						</>
					) : (
						<>
							<CustomButton
								// type="submit"
								// title="Submit Order"
								color="primary"
								title={
									btnLoading ? (
										<CircularProgress size={16} style={{ color: 'var(--default-text-color)' }} />
									) : (
										'Submit Order'
									)
								}
								disabled={isDisabled || isDisableButton(selectedDate)}
								handleClick={maxPriceWarning}
								styles={{
									width: '143px',
									height: '36px',
									borderRadius: '4px',
								}}
							/>
						</>
					)}
					<Box sx={{ cursor: 'pointer', marginLeft: '10px' }} onClick={() => setOpenModal(false)}>
						<ModalCloseIcon />
					</Box>
				</Box>
			</Box>
			<Divider style={{ width: '100%' }} />
			<Box
				display="flex"
				justifyContent={windowDimensions?.width <= 800 ? 'space-between' : 'flex-end'}
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					p: '20px',
					textAlign: 'end',
				}}
			>
				{windowDimensions?.width <= 800 ? (
					<Box sx={{ display: 'flex', alignItems: 'center' }}>
						{canCreateCart ? (
							<CustomTextButton
								title="Edit Cart"
								onClick={() => {
									setOpenModal(false);
									setCartItemModal(true);
									setWidth('1118px');
								}}
							/>
						) : null}
						{canClearCart ? (
							<CustomTooltip placement="top" title="Remove All Items from Cart">
								<IconButton onClick={clearCart}>
									{/* @ts-ignore */}
									<img src={Cart} width="22px" height="20px" alt="shopping-cart" />
								</IconButton>
							</CustomTooltip>
						) : (
							<CustomTooltip
								placement="top"
								title="You do not have permission to clear cart. Contact 
				an administrator to get permission."
							>
								<span>
									<IconButton disabled>
										{/* @ts-ignore */}
										<img src={Cart} width="22px" height="20px" alt="shopping-cart" />
									</IconButton>
								</span>
							</CustomTooltip>
						)}
						{canSaveCart ? (
							<CustomTooltip placement="top" title="Save For Review">
								<IconButton onClick={handleSaveForReview}>
									<SaveReviewIcon />
								</IconButton>
							</CustomTooltip>
						) : (
							<CustomTooltip
								placement="top"
								title={`You do not have permission to edit orderbook. Contact 
							an administrator to get permission.`}
							>
								<span>
									<IconButton disabled>
										<SaveReviewIcon stroke="#cacaca" />
									</IconButton>
								</span>
							</CustomTooltip>
						)}
					</Box>
				) : null}
				{windowDimensions?.width > 800 ? (
					<CustomDateTimePicker
						label="Select Date and Time"
						styles={{ width: '297px', height: '36px' }}
						selectedDateTime={selectedDateTime}
						onDateTimeChange={(dateTime) => {
							setSelectedDateTime(dateTime);
						}}
						windowDimensions={windowDimensions}
						maxDateTime={selectedDate}
						disabled={true}
					/>
				) : null}
				<Box>
					<Typography variant="body2" sx={{ mb: 1 }}>
						{/* @ts-ignore */}
						Total Qty: {itemsData?.reduce((total, item) => total + item?.quantity, 0)} items
					</Typography>
					<Typography variant="body2" sx={{ fontWeight: '700' }}>
						Total Amount: ₹ {totalPrice}
					</Typography>
					<RenderLessAndPayableAmount rewardsInfo={rewardsInfo} total={totalPrice} />
				</Box>
			</Box>
			<RenderCreditWarning creditInfo={creditInfo} rewardsInfo={rewardsInfo} total={totalPrice} />
			<Box sx={{ p: '16px' }}>
				{warning ? (
					<Warning
						onClick={handleSubmitOrder}
						message="The prices of some items have been updated by the supplier. Please review the new prices before checkout."
						btnStyles={{ width: '215px' }}
						tootip={!selectedDate}
						tooltipTitle="Select date first"
					/>
				) : null}
			</Box>
			<Box width="100%">
				<Box sx={{ px: '16px' }}>
					{windowDimensions?.width <= 800 ? (
						<Box sx={{ marginBottom: '16px' }}>
							<CustomDateTimePicker
								label="Select Date and Time"
								styles={{ width: '100%', height: '36px' }}
								selectedDateTime={selectedDateTime}
								onDateTimeChange={(dateTime) => {
									setSelectedDateTime(dateTime);
								}}
								windowDimensions={windowDimensions}
								maxDateTime={selectedDate}
								disabled={true}
							/>
						</Box>
					) : null}
					<Typography variant="body2" sx={{ mt: '-6px', color: 'var(--color-font-grey)' }}>
						Request Delivery Date
					</Typography>
					<CustomDatePicker
						styles={{ width: '100%' }}
						selectedDate={selectedDate}
						minDate={selectedDateTime}
						onDateChange={(newDate) => {
							//Getting date in UTC, adding minutes according to indian timezone diff
							setSelectedDate(convertUTCDateIntoIndianTimezone(newDate as Date));
						}}
					/>
					{/* <Typography variant="body2" sx={{ mt: '16px', color: 'var(--color-font-grey)' }}>
						Leave a comment
					</Typography>
					<StyledTextareaAutosize
						value={comment}
						onChange={(e) => setComment(e.target.value)}
						placeholder="leave a comment"
						maxLength={200}
					/> */}
					<Box sx={{ marginTop: '8px' }}>
						<LabeledTextField
							label="Leave a comment"
							value={comment}
							onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
								setComment(e.target.value as string)
							}
							multiline
							rows={4}
							placeholder="leave a comment"
							styles={{ width: '100%' }}
						/>
					</Box>
				</Box>
				<Box sx={{ p: '16px', pb: '20px' }}>
					<Box display="flex" width="100%" justifyContent="space-between" sx={{ mb: '16px' }}>
						<Typography variant="body1">Your Products</Typography>
						<Typography variant="body2" style={{ color: 'var(--lighter-text-color)' }}>
							{itemsData?.length} Products
						</Typography>
					</Box>
					{/* <ProductsListing products={itemsData} />  */}
					<div
						style={{ height: isMobileWidth ? 'unset' : 'calc(100vh - 500px)', overflow: 'auto' }}
					>
						{itemsData?.map((product: any) => {
							return (
								<ProductCard
									//@ts-ignore
									data={product}
									noCheckbox
									view="order"
									showDetails={showDetails}
									readOnly
								/>
							);
						})}
					</div>
				</Box>
			</Box>
			{modals()}
			<CreditLimitWarningModal
				showCreditWarningModal={showCreditWarningModal}
				setShowCreditWarningModal={setShowCreditWarningModal}
				setOpenModal={setOpenModal}
				creditInfo={creditInfo}
			/>
		</Box>
	);
}

export function CreditLimitWarningModal({
	showCreditWarningModal,
	setShowCreditWarningModal,
	setOpenModal,
	creditInfo,
}: any) {
	const navigate = useNavigate();
	const { id } = useParams();
	const { supplierInfo } = creditInfo || {};
	const { phone } = supplierInfo || {};

	const handleChatNow = () => {
		setOpenModal(false);
		if (phone) {
			const chatId = phone;
			navigate(`/restaurants/${id}/chat/${chatId}`);
		}
	};

	return (
		<CustomModal open={showCreditWarningModal} setOpen={setShowCreditWarningModal} header={false}>
			<Box p={2}>
				<Typography variant="body1">
					Order submission failed. There is no credit available and the supplier has disabled order
					submission when payments are due. Please chat with the Supplier to resolve the issue.
				</Typography>
				<Stack direction="row" justifyContent="flex-end" mt={2} gap={2}>
					<CustomButton
						title="Cancel"
						handleClick={() => setShowCreditWarningModal(false)}
						color="secondary"
					/>
					<CustomButton color="primary" title="Chat Now" handleClick={() => handleChatNow()} />
				</Stack>
			</Box>
		</CustomModal>
	);
}

export function RenderCreditWarning({ creditInfo, rewardsInfo, total }: any) {
	const { rewardsDiscount } = rewardsInfo || {
		rewardsDiscount: 0,
	};
	const totalPayable = total - rewardsDiscount;

	if (!creditInfo?.isActive) return null;

	if (totalPayable > creditInfo?.creditAvailable && !(creditInfo?.creditAvailable <= 0)) {
		return (
			<Stack p={1}>
				<Stack
					direction={'row'}
					justifyContent={'center'}
					alignItems={'center'}
					sx={{
						backgroundColor: 'rgb(253, 237, 237)',
						padding: '6px 12px',
						borderRadius: '4px',
						color: 'rgb(204, 0, 0)',
					}}
					gap={1}
				>
					<ErrorOutlineRoundedIcon sx={{ color: 'rgb(204, 0, 0) !important' }} />
					The total payable amount is more than the credit available (Rs.{' '}
					{creditInfo?.creditAvailable})
				</Stack>
			</Stack>
		);
	}

	if (creditInfo?.creditAvailable <= 0) {
		return (
			<Stack p={1}>
				<Stack
					direction={'row'}
					justifyContent={'center'}
					alignItems={'center'}
					sx={{
						backgroundColor: 'rgb(253, 237, 237)',
						padding: '6px 12px',
						borderRadius: '4px',
						color: 'rgb(204, 0, 0)',
					}}
					gap={1}
				>
					<ErrorOutlineRoundedIcon sx={{ color: 'rgb(204, 0, 0) !important' }} />
					There is no credit available
				</Stack>
			</Stack>
		);
	}
	return null;
}

export default CartComponent;
